import React from 'react';
import { useTranslation } from 'react-i18next';

import { InventoryItem } from './InventoryItem';
import { Pagination } from '../../../components/Pagination';
import { useSetFilters } from '../../../hooks/useSetFilters';
import { FormField } from '../../../components/FormField';
import { CustomSelect } from '../../../components/Shared/CustomSelect';

export const InventoryItems = ({ inventory, statuses }) => {
    const setFilters = useSetFilters();
    const { t } = useTranslation();

    const searchParams = new URLSearchParams(location.search);
    const category = parseInt(searchParams.get('category')) || '';
    const search = (searchParams.get('search') || '').toLowerCase();
    const page = parseInt(searchParams.get('page') || '') || 1
    const perPage = parseInt(searchParams.get('per_page') || '') || 10

    // filter by category and search from query params
    const filteredDishes = category
        ? inventory.filter((dish) => {
              if (search) {
                  return (dish.title || dish.name || "").toLowerCase().includes(search) && dish.category_id === category;
              }
              return dish.category_id === category;
          })
        : search
        ? inventory.filter((dish) => (dish.title || dish.name || "").toLowerCase().includes(search))
        : inventory;

    // pagination
    const numPages = Math.ceil(filteredDishes.length / perPage || 1);
    const paginatedDishes = filteredDishes.slice((page - 1) * perPage, page * perPage)

    const onChangePage = (value) => {
        setFilters({ page: value });
    };

    const onChangePerPage = ({ value }) => {
        setFilters({ per_page: value, page: 1 });
    };

    return (
        <div className="max-w-6xl relative">
            {filteredDishes.length > 0 ? (
                <>
                    <div className="min-w-full">
                        <div className="flex text-sm">
                            <div className="w-1/2 col-end-3 pl-5 py-3 text-sm font-bold text-left">{t('Name')}</div>
                            <div className="flex justify-end w-full">
                                <div className="w-[135px] pl-5 py-3 text-sm font-bold">{t('Stock count')}</div>
                                <div className="w-[170px] pl-5 py-3 text-sm font-bold">{t('Product availability')}</div>
                                <div className="w-[170px] pl-5 py-3 text-sm font-bold">{t('Stock status')}</div>
                            </div>
                        </div>
                        <div className="flex flex-col gap-2">
                            {paginatedDishes.map((dish) => {
                                return <InventoryItem statuses={statuses} dish={dish} key={dish.id} />;
                            })}
                        </div>
                        <div className="flex justify-center">
                            <Pagination isPerPage={true} perPage={perPage} className="max-w-2xl mt-5 ml-12" setCurrentPage={onChangePage} setPerPage={onChangePerPage} currentPage={page} numPages={numPages} />
                                <FormField className="ml-5">
                                    <CustomSelect
                                        isSearchable={false}
                                        defaultValue={{ label: perPage, value: perPage }}
                                        onChange={onChangePerPage}
                                        menuPlacement="top"
                                        options={[{ label: 5, value: 5 }, { label: 10, value: 10 }, { label: 20, value: 20 }, { label: 50, value: 50, }, { label: 100, value: 100 }]}
                                    />
                                </FormField>
                        </div>
                    </div>
                </>
            ) : (
                <div className="bg-white ">
                    <h1 className="text-2xl font-bold mb-3">{t('Inventory is empty')}</h1>
                    {t(
                        'Manage your inventory by selecting the menu items you would like to publish to this restaurant. Using the controls provided, you can also update the status of selected menu items as in stock, sold out, or off the menu.'
                    )}
                </div>
            )}

        </div>
    );
};
